import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
export { default as getFolderChangeDigestAction } from './actions/getFolderChangeDigestAction';
export { default as getRollupText } from './actions/getRollupText';
export { default as updateWatermarksAndResetRollup } from './actions/updateWatermarksAndResetRollup';
export { default as focusedInboxRollupStore } from './store/store';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "FocusedInboxRollupStore"*/ './lazyIndex')
);

import { onSelectedAccountChanged } from 'owa-account-source-list-store';

registerLazyOrchestrator(
    onSelectedAccountChanged,
    lazyModule,
    m => m.resetFocusedInboxOrchestrator
);
